module.exports = __webpack_public_path__ + "static/fonts/iconfont.8ba5ac21.eot";